import store from "../../../store";

import onLoad from "../../../store/on-load";
import resolveRoutedVolume from "../../../store/getters/resolve/resolve-routed-volume";
import autoVolume from "../../../store/getters/auto/auto-volume";

// A helper function to redirect to a valid route
// when entering or updating routes in Hub components.
export default async function ensureValidVolume(route, next) {
  await onLoad(store);

  const routedVolume = resolveRoutedVolume(route, store);
  if (routedVolume) {
    // We have a volume - which is all we need. Stay here.
    next();
    return;
  }

  // We do not have a routed volume.
  // Let's see if there's any volume at all to route to.
  const volume = autoVolume(store);

  if (!!route.volumeSlug && !volume) {
    // We came here with a volume slug,
    // but there isn't even a single volume available.
    // Neither can the volume slug match,
    // nor can we redirect to any other available volume.
    // Let's go to a parameterless '/' and stay there.
    next({
      name: "Hub",
    });
    return;
  }

  // We came here with a volume slug, which was invalid,
  // or we came here all without a volume slug.
  // However, we have found a volume in the container
  // which we will now redirect to.

  next({
    name: "HubWithVolume",
    params: {
      volumeSlug: volume.slug,
    },
    // This is important. Vue router compares the redirect
    // route with the currently active route, not with
    // the one requested by the user! E.g. if the active
    // route is a valid '/jaargang-26-2020-2021/', and
    // a user enters an invalid route '/grmpf/', then
    // vue router will compare our redirect to the valid
    // '/jaargang-26-2020-2021/' with the active route
    // ('/jaargang-26-2020-2021/') and not with the one
    // we are redirecting away from ('/grmpf/') before
    // it has even become active. Without `force: true`,
    // vue router sees that our redirect is equal to the
    // active route and rejects the navigation. This,
    // however, means that '/grmpf/' stays in the address
    // bar. We don't want that, so we force push our
    // new (and possibly old) route.
    force: true,
  });
}
